<template>
    <div>
        <div class="card">
            <div class="card-body p-5">
                <form @submit.prevent="submitPackageInfo">
                    <div class="form-group">
                        <label class="form-label">{{$t('label.title')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-text"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="newTitle" required="">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.category')}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend w-100">
                                <label class="input-group-text border-right-0">
                                    <i class="fas fa-tag"></i>
                                </label>
                                <multiselect 
                                    :value="newCategory" 
                                    :options="categories" 
                                    label="text" track-by="id" 
                                    :searchable="false" 
                                    :show-labels="false" 
                                    openDirection="below" 
                                    @select="selectCategory">
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div v-if="isEdit" class="form-group mt-3">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="enablePackage" v-model="enable" @change="showDisablePackage">
                            <label class="custom-control-label" for="enablePackage">{{$t('label.enable')}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnPackageList">{{$t('button_link.cancel')}}</button>
                            <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.next')}}</button>
                        </div>
                        <div class="d-none col-6 text-right">
                            <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="disablePackage">Disable</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="disablePackage"></deleteModal>
    </div>
</template>

<script>
import DeleteModal from './../../Delete_Modal'
import {getCategoryText} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'packageInfo',
    props: {
        category: { type: Array },
        isEdit: { type: Boolean }
    },
    components:{
        DeleteModal
    },
    data(){
        return{
            step: 1,
            categories: [],
            itemID: 0, newTitle: "", newCategory: {}, enable: 1,
            result: {},
            disableToggleModal: false, sTitle: "",
        }
    },
    methods:{
        setCategoryOptions(){
            this.categories = this.category.slice(1, this.category.length)
            this.newCategory = this.categories[0]
        },
        selectCategory(item){
            this.newCategory = item;
        },
        submitPackageInfo(){
            this.result["title"] = this.newTitle;
            this.result["category"] = this.newCategory.id;
            this.result["isEnable"] = 1;
            this.$emit('submitPackageInfo', this.step, this.result);
        }, 
        returnPackageList(){
            this.$emit('returnPackageList');
        },
        editPackageInfo(item, category){
            this.setCategoryOptions();
            if(Object.keys(item).length != 0){
                this.itemID = item.itemID;
                this.newTitle = item.title;
                this.newCategory = {id: item.category, text: getCategoryText(item.category, category)};
                this.enable = item.isEnable;
                this.result = item;
            }
        },
        showDisablePackage(){
            var title = this.$i18n.t('header.disable', {'item': this.$i18n.t('subMenu.salon_menu_package')})
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.disable'),'item': this.result.title})
            this.$refs.deleteModal.showModal(title, message)
        },
        disablePackage(){
            this.result["isEnable"] = 0
            this.$emit('disablePackage', this.result)
            this.$refs.deleteModal.toggleModal = false
        },
        resetDisablePackage(){
            this.$refs.deleteModal.toggleModal = false
            this.enable = true;
        }
    }, 
    mounted(){
        let $vm = this;
        $vm.setCategoryOptions()
    }
}
</script>